"use client"

import type { JSX } from "react"

import type { FaqItem } from "@/consts/faq"

export function FaqAccordion({
  items,
}: {
  items: readonly FaqItem[]
}): JSX.Element {
  return (
    <div>
      {items.map((item) => (
        <details
          key={item.question}
          className="group border-b border-[var(--ink-10)] py-4"
        >
          <summary className="cursor-pointer list-none text-lg font-semibold text-[var(--ink-100)]">
            <span className="mr-2 inline-block transition group-open:rotate-90">
              ›
            </span>
            {item.question}
          </summary>
          <p className="mt-3 text-[var(--ink-80)]">{item.answer}</p>
        </details>
      ))}
    </div>
  )
}
